import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  homeWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.palette.background.default,
    height: '100vh',
    '& h4': {
      // `secondary.silver` is only declared in the DARK palette, so in light this
      // declaration was dropped and the heading simply inherited. Left out
      // entirely: keeping it would render the heading in a dark SURFACE colour in
      // dark mode, i.e. invisible.
      fontWeight: '200',
      marginTop: '60px',
    },
    '& a': {
      color: theme.palette.primary.main,
      fontSize: '18px',
    },
    '& div': {
      minWidth: '280px',
    },
    '& img': {
      display: 'block',
      margin: 'auto',
    },
    '& .MuiTextField-root': {
      marginBottom: '10px',
    },
  },
  home: {
    color: 'white',
    width: '100%',
    maxWidth: '600px',
    '& a': {
      margin: '50px 10px',
      '&:link': {
        color: theme.palette.primary.main,
        textDecoration: 'none',
      },
      '&:visited': {
        color: theme.palette.primary.main,
        textDecoration: 'none',
      },
      '&:hover': {
        color: '#ccc',
        textDecoration: 'underline',
      },
    },
  },
  homeLink: {
    padding: '40px 10px',
    textAlign: 'center',
  },
  logoContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '24px',
  },
  image: {
    margin: '0 !important',
    maxWidth: '80px',
    maxHeight: '100%',
  },
  // The lockup asset (4403x966, ~4.56:1) already contains the "TCG Scout"
  // wordmark, so it replaces the old mark + `company` text span pair. 340px
  // keeps roughly the footprint those two had together.
  logoLockup: {
    margin: '0 !important',
    width: '100%',
    maxWidth: '340px',
    height: 'auto',
    display: 'block',
  },
  company: {
    fontFamily: 'Sora, sans-serif',
    fontWeight: 'bold',
    fontSize: '42px',
    color: theme.palette.text.primary,

    '& span': {
      backgroundImage: 'linear-gradient(to right, #38bdf8 ,#67e8f9 , #60a5fa)',
      WebkitBackgroundClip: 'text',
      backgroundClip: 'text',
      color: 'transparent',
    },
  },
}));

export default useStyles;
